var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7509 10.1944C18.7509 9.47495 18.6913 8.94995 18.5624 8.40552H10.1795V11.6527H15.1001C15.0009 12.4597 14.4652 13.675 13.2747 14.4916L13.258 14.6003L15.9085 16.6126L16.0922 16.6305C17.7786 15.1041 18.7509 12.8583 18.7509 10.1944Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1789 18.75C12.5896 18.75 14.6133 17.9722 16.0915 16.6305L13.2741 14.4916C12.5201 15.0068 11.5082 15.3666 10.1789 15.3666C7.81779 15.3666 5.81385 13.8402 5.0995 11.7305L4.99479 11.7392L2.23874 13.8295L2.2027 13.9277C3.67093 16.786 6.6868 18.75 10.1789 18.75Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10002 11.7305C4.91153 11.186 4.80245 10.6027 4.80245 9.99992C4.80245 9.3971 4.91153 8.81379 5.0901 8.26935L5.08511 8.1534L2.29451 6.02954L2.20321 6.0721C1.59808 7.25823 1.25085 8.5902 1.25085 9.99992C1.25085 11.4096 1.59808 12.7415 2.20321 13.9277L5.10002 11.7305Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1789 4.63331C11.8555 4.63331 12.9864 5.34303 13.6313 5.93613L16.1511 3.525C14.6035 2.11528 12.5896 1.25 10.1789 1.25C6.68682 1.25 3.67094 3.21387 2.2027 6.07218L5.0896 8.26944C5.81387 6.15972 7.81782 4.63331 10.1789 4.63331Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a5b43a422854c7d07ec91a8a78f6c193.svg";
export { ForwardRef as ReactComponent };